import React from 'react';
import { AllClaims } from '../../components/admin/AllClaims';

export const Messages2 = () => {
  // Only show claims with this payment status
  const hasChat = true;
   const unreadFirst=true;
  return (
    <>
      <AllClaims hasChat={hasChat} unreadFirst={unreadFirst} />
    </>
  );
};
